import { render } from "./basicPage.vue?vue&type=template&id=21b34f3d"
import script from "./basicPage.vue?vue&type=script&lang=js"
export * from "./basicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__